import { Users2 } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import ShareToEmployeeModal from "../ShareToEmployeeModal/ShareToEmployeeModal";

interface ShareToEmployeeButtonProps {
  resourceUuid: string;
  resourceTitle: string;
  className?: string;
}

export function ShareToEmployeeButton({
  resourceUuid,
  resourceTitle,
  className,
}: ShareToEmployeeButtonProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Button
        className={`h-8 w-8 p-0 ${className}`}
        onClick={() => setIsModalOpen(true)}
        size="sm"
        title="Share with employees"
        variant="ghost"
      >
        <Users2 className="h-4 w-4" />
        <span className="sr-only">Share with employees</span>
      </Button>

      <ShareToEmployeeModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        resourceTitle={resourceTitle}
        resourceUuid={resourceUuid}
      />
    </>
  );
}
